



































import { Vue, Component, Prop } from 'vue-property-decorator';
import Button from '@/components/Button.vue';
import Icon from '@/components/Icon.vue';
import { IDocumentOption } from '@signing-page/documents/types/document-option';
import { ESidebarOptionType } from '@signing-page/documents/types/enums/sidebar-option-type';
import { DURATION } from '@signing-page/common/constants/tooltip';

@Component({
  components: {
    Button,
    Icon,
  },
  data: () => ({
    ESidebarOptionType,
  }),
})
export default class MainMenuButton extends Vue {
  @Prop() isPreview: boolean;
  @Prop() option: IDocumentOption;
  @Prop() recipientsLength: number;
  @Prop() newCommentsCount: number;

  tooltipOpen: boolean = false;

  get previewDisable(): boolean {
    return this.option.disableInPreview && this.isPreview;
  }

  get buttonText(): string {
    return this.option.type === ESidebarOptionType.Recipient
      ? this.recipientsLabel
      : this.$t(this.option.title).toString();
  }

  get recipientsLabel(): string {
    if (this.recipientsLength === 1) {
      return this.$t('one-recipient').toString();
    }
    return this.$t('recipients').toString();
  }

  showTooltip() {
    if (this.tooltipOpen) {
      return;
    }
    this.tooltipOpen = true;
    setTimeout(() => {
      this.tooltipOpen = false;
    }, DURATION);
  }

  handleMenuClick() {
    if (this.previewDisable) {
      this.showTooltip();
      return;
    }
    this.$emit('click', this.option.type);
  }
}
